import { Toaster as Sonner, toast } from "sonner";

/** Bottom-right toasts on the dark sidebar palette. Use `toast.success/error/info` or `toast(message)`. */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      duration={2600}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "flex items-center gap-2.5 rounded-md bg-sidebar px-3.5 py-2.5 text-base text-sidebar-fg-strong shadow-modal",
          title: "font-medium",
          description: "text-sidebar-fg",
        },
      }}
      icons={{
        success: <span aria-hidden className="size-2 rounded-full bg-ok" />,
        error: <span aria-hidden className="size-2 rounded-full bg-err" />,
        warning: <span aria-hidden className="size-2 rounded-full bg-warn" />,
        info: <span aria-hidden className="size-2 rounded-full bg-accent" />,
      }}
    />
  );
}

export { toast };
